import {
  UPDATE_START_INFO,
  UPDATE_START_ADDRESS,
  UPDATE_END_INFO,
  UPDATE_END_ADDRESS,
  UPDATE_SZHK_START_INFO,
  UPDATE_SZHK_START_ADDRESS,
  UPDATE_SZHK_END_INFO,
  UPDATE_SZHK_END_ADDRESS,
  UPDATE_SZHK_WAY_INFO,
  UPDATE_SZHK_WAY_ADDRESS,
  UPDATE_WAY_INFO,
  UPDATE_WAY_ADDRESS,
  UPDATE_HISTORY_ADDRESS,
  UPDATE_CURRENT_CITY,
  UPDATE_HK_START,
  UPDATE_SELECT_OPEN_CITY,
  UPDATE_LINE_DISTANCE
} from '../mutation-types'

import BMap from 'BMap'
import jsonp from 'superagent-jsonp'
import superagent from 'superagent'
import Order from './order'

const state = {
  hk_start: window.localStorage.getItem('hk_start'),
  history_address: window.localStorage.getItem('history_address') ? JSON.parse(window.localStorage.getItem('history_address')) : [],
  start_info: window.localStorage.getItem('start_info'),
  start_address: window.localStorage.getItem('start_address'),
  end_info: window.localStorage.getItem('end_info'),
  end_address: window.localStorage.getItem('end_address'),
  way_info: window.localStorage.getItem('way_info'),
  current_city: null,
  select_open_city: window.localStorage.getItem('cache_select_open_city') || '',
  line_distance: window.localStorage.getItem('cache_line_distance') ? JSON.parse(window.localStorage.getItem('cache_line_distance')) : {}, // 计算的开始地址和结束地址的距离和用时
  way_address: (function () {
    var data = JSON.parse(window.localStorage.getItem('way_address'))
    var _arr = []
    if (data) {
      for (var i = 0, len = data.length; i < len; i++) {
        if (data[i].address) {
          _arr.push(data[i])
        }
      }
    }
    return _arr
  })(),
  // 因为深港互通地址有限制，所以起始点不能共用
  szhk_start_info: window.localStorage.getItem('szhk_start_info'),
  szhk_end_info: window.localStorage.getItem('szhk_end_info'),
  szhk_start_address: window.localStorage.getItem('szhk_start_address'),
  szhk_end_address: window.localStorage.getItem('szhk_end_address'),
  szhk_way_info: window.localStorage.getItem('szhk_way_info'),
  szhk_way_address: (function () {
    var data = JSON.parse(window.localStorage.getItem('szhk_way_address'))
    var _arr = []
    if (data) {
      for (var i = 0, len = data.length; i < len; i++) {
        if (data[i].address) {
          _arr.push(data[i])
        }
      }
    }
    return _arr
  })()
}

const mutations = {
  // 更新 起点－信息 eg '省份－城市－经度－纬度'
  [UPDATE_START_INFO] (state, data) {
    var _info = data
    if (data) {
      _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat
    }
    state.start_info = _info
    window.localStorage.setItem('start_info', _info)
  },
  // 更新 起点－地名
  [UPDATE_START_ADDRESS] (state, address) {
    state.start_address = address
    window.localStorage.setItem('start_address', address)
  },
  // 更新 终点－信息 eg '省份－城市－经度－纬度'
  [UPDATE_END_INFO] (state, data) {
    var _info = data
    if (data) {
      _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat
    }
    state.end_info = _info
    window.localStorage.setItem('end_info', _info)
  },
  // 更新 终点－地名
  [UPDATE_END_ADDRESS] (state, address) {
    state.end_address = address
    window.localStorage.setItem('end_address', address)
  },
  // 更新 途径站点
  [UPDATE_WAY_ADDRESS] (state, data) {
    if (data.type === 'add') {
      state.way_address.push(data.data)
    } else if (data.type === 'reduce') {
      state.way_address.splice(data.index, 1)
    } else if (data.index) {
      state.way_address.splice(data.index, 1, data.data)
    } else {
      // 传空对象就是清空
      state.way_address = []
    }
    window.localStorage.setItem('way_address', JSON.stringify(state.way_address))
  },
  // 更新 途径站点-信息
  [UPDATE_WAY_INFO] (state, info) {
    state.way_info = info
    window.localStorage.setItem('way_info', info)
  },
  // 更新 起点－信息 eg '省份－城市－经度－纬度'
  [UPDATE_SZHK_START_INFO] (state, data) {
    var _info = data
    if (data) {
      _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat
    }
    state.szhk_start_info = _info
    window.localStorage.setItem('szhk_start_info', _info)
  },
  // 更新 起点－地名
  [UPDATE_SZHK_START_ADDRESS] (state, address) {
    address = address || ''
    state.szhk_start_address = address
    window.localStorage.setItem('szhk_start_address', address)
  },
  // 更新 终点－信息 eg '省份－城市－经度－纬度'
  [UPDATE_SZHK_END_INFO] (state, data) {
    var _info = data
    if (data) {
      _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat
    }
    state.szhk_end_info = _info
    window.localStorage.setItem('szhk_end_info', _info)
  },
  // 更新 终点－地名
  [UPDATE_SZHK_END_ADDRESS] (state, address) {
    address = address || ''
    state.szhk_end_address = address
    window.localStorage.setItem('szhk_end_address', address)
  },
  // 更新 途径站点
  [UPDATE_SZHK_WAY_ADDRESS] (state, data) {
    if (data.type === 'add') {
      state.szhk_way_address.push(data.data)
    } else if (data.type === 'reduce') {
      state.szhk_way_address.splice(data.index, 1)
    } else if (data.index) {
      state.szhk_way_address.splice(data.index, 1, data.data)
    } else {
      // 传空对象就是清空
      state.szhk_way_address = []
    }
    window.localStorage.setItem('szhk_way_address', JSON.stringify(state.szhk_way_address))
  },
  // 更新 途径站点-信息
  [UPDATE_SZHK_WAY_INFO] (state, info) {
    state.szhk_way_info = info
    window.localStorage.setItem('szhk_way_info', info)
  },
  [UPDATE_HISTORY_ADDRESS] (state, data) {
    // 如果已经存在列表里，则删除后插入到前面
    for (var i = 0, len = state.history_address.length; i < len; i++) {
      var _item = state.history_address[i]
      if (_item.lng === data.lng && _item.lat === _item.lat) {
        state.history_address.splice(i, 1)
        break
      }
    }
    state.history_address.unshift(data)
    // 只存储十条
    if (state.history_address.length > 10) {
      state.history_address.pop()
    }
    window.localStorage.setItem('history_address', JSON.stringify(state.history_address))
  },
  [UPDATE_CURRENT_CITY] (state, city) {
    state.current_city = city
    // state.current_position = {
    //   lat: data.lat,
    //   lng: data.lng
    // }
  },
  [UPDATE_SELECT_OPEN_CITY] (state, city) {
    state.select_open_city = city
    window.localStorage.setItem('cache_select_open_city', city)
  },
  [UPDATE_LINE_DISTANCE] (state, params) {
    if (params) {
      state.line_distance = params
      window.localStorage.setItem('cache_line_distance', JSON.stringify(params))
    }
  },
  [UPDATE_HK_START] (state, val) {
    state.hk_start = val
    window.localStorage.setItem('hk_start', val)
  }
}

const actions = {
  // 深港互通，互换开始地址与结束地址
  switchAddress ({ commit, state }) {
    var _szhk_start_address = JSON.parse(JSON.stringify(state.szhk_start_address))
    var _szhk_start_info = JSON.parse(JSON.stringify(state.szhk_start_info))
    var _szhk_end_address = JSON.parse(JSON.stringify(state.szhk_end_address))
    var _szhk_end_info = JSON.parse(JSON.stringify(state.szhk_end_info))
    var _params
    commit('UPDATE_SZHK_START_ADDRESS', _szhk_end_address)
    if (_szhk_end_info) {
      _params = _szhk_end_info.split('-')
      commit('UPDATE_SZHK_START_INFO', {
        province: _params[0],
        city: _params[1],
        lng: _params[2],
        lat: _params[3]
      })
    }
    commit('UPDATE_SZHK_END_ADDRESS', _szhk_start_address)
    if (_szhk_start_info) {
      _params = _szhk_start_info.split('-')
      commit('UPDATE_SZHK_END_INFO', {
        province: _params[0],
        city: _params[1],
        lng: _params[2],
        lat: _params[3]
      })
    }
    if (state.way_address && state.way_address.length > 0) {
      state.way_address.reverse()
      window.localStorage.setItem('way_address', JSON.stringify(state.way_address))
    }
    commit(UPDATE_HK_START, !state.hk_start)
  },
  // params { keyword: 'xxx', city: 'xxx' }
  searchAddress ({ commit, state }, params) {
    var _city = params.city ? params.city : (state.select_open_city || state.current_city || '')
    if (_city.indexOf('市') === -1 && _city.indexOf('香港') === -1 && _city.indexOf('澳门') === -1) {
      _city = _city + '市'
    }
    if (params.keyword.length > 0) {
      var _param = {
        ak: 'b2tdmZtPCKfwW8iwn5svaT03',
        region: _city,
        output: 'json',
        // city_limit: _city ? 'true' : 'false', // 增加城市限制搜索
        query: params.keyword
      }
      return new Promise(function (resolve, reject) {
        superagent
        .get('https://api.map.baidu.com/place/v2/suggestion')
        .query(_param)
        .set('Accept', 'application/json')
        .use(jsonp)
        .end(function (err, res) {
          if (err) {
            // console.log(err)
          } else {
            // 过滤location
            var _arr = []
            for (var i = 0, len = res.body.result.length; i < len; i++) {
              var _place = res.body.result[i]
              if (_place.location) {
                _arr.push({
                  address_title: _place.name,
                  point: _place.location
                })
              }
            }
            resolve(_arr)
          }
        })
      })
    }
  },
  // 逆解析 http://api.map.baidu.com/geocoder/v2/
  geocoder ({ commit, state }, arr) {
    var _promise_arr = []
    for (var i = 0, len = arr.length; i < len; i++) {
      var _p = new Promise(function (resolve, reject) {
        superagent
        .get('https://api.map.baidu.com/geocoder/v2/')
        .query({
          output: 'json',
          ak: 'b2tdmZtPCKfwW8iwn5svaT03',
          location: arr[i].point.lat + ',' + arr[i].point.lng
        })
        .set('Accept', 'application/json')
        .use(jsonp)
        .end(function (err, res) {
          if (err) {
            // console.log(err)
          } else {
            resolve(res)
          }
        })
      })
      _promise_arr.push(_p)
    }
    return Promise.all(_promise_arr)
  },
  getTwoPlaceDistance ({ commit, state }, type) {
    if (Order.state.type !== 'business') {
      _start = state.szhk_start_info.split('-')[3] + ',' + state.szhk_start_info.split('-')[2]
      _end = state.szhk_end_info.split('-')[3] + ',' + state.szhk_end_info.split('-')[2]
    } else {
      var _start = state.start_info.split('-')[3] + ',' + state.start_info.split('-')[2]
      var _end = state.end_info.split('-')[3] + ',' + state.end_info.split('-')[2]
    }
    var _param = {
      ak: 'b2tdmZtPCKfwW8iwn5svaT03',
      origins: _start,
      destinations: _end,
      output: 'json'
    }
    if (type === 'wayPoints') {
      // 启动计算途径点
      _param.origin = _start
      _param.destination = _end
      _param.waypoints = ''
      if (Order.state.type !== 'business') {
        if (state.szhk_way_address && state.szhk_way_address.length > 0) {
          _param.waypoints = state.szhk_way_address.map(function (val, index) {
            // 返回经纬度参数
            if (val.lat) {
              return (val.lat + ',' + val.lng)
            } else {
              return ''
            }
          }).join('|')
        }
      } else {
        if (state.way_address && state.way_address.length > 0) {
          _param.waypoints = state.way_address.map(function (val, index) {
            // 返回经纬度参数
            if (val.lat) {
              return (val.lat + ',' + val.lng)
            } else {
              return ''
            }
          }).join('|')
        }
      }
      return new Promise(function (resolve, reject) {
        superagent
          .get('https://api.map.baidu.com/direction/v2/driving')
          .query(_param)
          .set('Accept', 'application/json')
          .use(jsonp)
          .end(function (err, res) {
            var _cache = {}
            var _result = {}
            if (err) {
              console.log(err)
            } else {
              _result.status = res.body.status
              if (res.body.status === 0) {
                // 构造数据
                if (res.body.result && res.body.result.routes && res.body.result.routes.length > 0) {
                  _cache = res.body.result.routes[0]
                  _result.result = {
                    distance: {
                      text: parseFloat(_cache.distance / 1000).toFixed(2) + '公里',
                      value: _cache.distance
                    },
                    duration: {
                      text: (parseFloat(_cache.duration / 60) > 60) ? parseFloat(_cache.duration / 3600).toFixed(2) + '小时' : parseFloat(_cache.duration / 60).toFixed(2) + '分钟',
                      value: _cache.duration
                    }
                  }
                  commit(UPDATE_LINE_DISTANCE, _result.result)
                }
              }
              resolve(_result)
            }
          })
      })
    } else {
      return new Promise(function (resolve, reject) {
        superagent
          .get('https://api.map.baidu.com/routematrix/v2/driving')
          .query(_param)
          .set('Accept', 'application/json')
          .use(jsonp)
          .end(function (err, res) {
            var _result = {}
            if (err) {
              console.log(err)
            } else {
              _result.status = res.body.status
              // 构造数据
              if (res.body.result && res.body.result.length > 0) {
                _result.result = res.body.result[0]
                commit(UPDATE_LINE_DISTANCE, _result.result)
              }
              resolve(_result)
            }
          })
      })
    }
  },
  setOrderLocation ({ commit, state }, data) {
    if (data.type === 'way') {
      var _data = {
        address: data.address_title,
        lng: data.lng,
        lat: data.lat,
        city: data.city,
        province: data.province,
        address_detail: data.address
      }
      commit(Order.state.type === 'business' ? 'UPDATE_WAY_ADDRESS' : 'UPDATE_SZHK_WAY_ADDRESS', {
        type: 'update',
        index: data.index,
        data: _data
      })
    } else {
      var infoType = Order.state.type === 'business' ? UPDATE_START_INFO : UPDATE_SZHK_START_INFO
      var addressType = Order.state.type === 'business' ? UPDATE_START_ADDRESS : UPDATE_SZHK_START_ADDRESS
      if (data.type === 'end') {
        infoType = Order.state.type === 'business' ? UPDATE_END_INFO : UPDATE_SZHK_END_INFO
        addressType = Order.state.type === 'business' ? UPDATE_END_ADDRESS : UPDATE_SZHK_END_ADDRESS
      }
      commit(infoType, data)
      commit(addressType, data.address_title)
    }
    commit(UPDATE_HISTORY_ADDRESS, data)
  },
  updateWayAddress ({ commit, state }, data) {
    var _len = Order.state.type === 'business' ? state.way_address.length : state.szhk_way_address.length
    if (data.type !== 'add' || _len !== 3) {
      commit(Order.state.type === 'business' ? 'UPDATE_WAY_ADDRESS' : 'UPDATE_SZHK_WAY_ADDRESS', data)
    }
  },
  // // 获取用户定位
  initCurrentPos ({ commit, state }) {
    if (!state.current_position) {
      var geolocation = new BMap.Geolocation()
      geolocation.getCurrentPosition(function (result) {
        if (this.getStatus() === window.BMAP_STATUS_SUCCESS) {
          commit(UPDATE_CURRENT_CITY, result.address.city)
        }
      })
    }
  },
  selectOpenCity ({ commit, state }, city) {
    commit(UPDATE_SELECT_OPEN_CITY, city)
  }
}

export default {
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/location.js